import {rtkQueryErrorMiddleware} from "@/error/ErrorMiddleware";
import adminApi from "@/services/adminApi";
import authApi from "@/services/authApi";
import campaignApi from "@/services/campaignApi";
import chatApi from "@/services/chatApi";
import instancesApi from "@/services/instancesApi";
import leadsApi from "@/services/leadsApi";
import listBuildingApi from "@/services/listBuildingApi";
import notificationsApi from "@/services/notificationsApi";
import organisationApi from "@/services/organisationApi";
import {configureStore} from "@reduxjs/toolkit";
import organizationSlice from "./organizationStore";
import userSlice from "./userStore";

export const store = configureStore({
  reducer: {
    [userSlice.name]: userSlice.reducer,
    [organizationSlice.name]: organizationSlice.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [organisationApi.reducerPath]: organisationApi.reducer,
    [instancesApi.reducerPath]: instancesApi.reducer,
    [listBuildingApi.reducerPath]: listBuildingApi.reducer,
    [chatApi.reducerPath]: chatApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [campaignApi.reducerPath]: campaignApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [leadsApi.reducerPath]: leadsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      adminApi.middleware,
      organisationApi.middleware,
      instancesApi.middleware,
      listBuildingApi.middleware,
      chatApi.middleware,
      authApi.middleware,
      campaignApi.middleware,
      notificationsApi.middleware,
      leadsApi.middleware,
      rtkQueryErrorMiddleware
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
